export const ALLOWED_CHARS = /^([)(№?;:!,.+/\\~^&*@#$%_=*{}[\]<>|`'"\sA-Za-z0-9-]*)$/gi

export const URL_CHARS =
  /^https?:\/\/(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,6}\.?|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[/?]\S+)$/i

// Decentraland sample https://play.decentraland.org/?NETWORK=mainnet&position=-93,15
export const JUMP_URL_DCL =
  /^https:\/\/play\.decentraland\.org\/\?NETWORK=mainnet&position=-?([1,2]?[0-9]{1,2}|300),-?([1,2]?[0-9]{1,2}|300)$/i

// Roblox sample https://www.roblox.com/games/12503686942/SamGame2802
export const JUMP_URL_ROBLOX = /^https:\/\/www\.roblox\.com\/games\/[0-9]+\/\S{1,50}$/i

// Voxels sample https://www.voxels.com/play?coords=W@18W,1N
export const JUMP_URL_VOXELS = /^https:\/\/www\.voxels\.com\/play\?coords=[UWSEN@,0-9]+$/

// Voxels sample 2 https://www.voxels.com/spaces/4afe4e0c-3175-478e-bade-589ed40e2dff/play
export const JUMP_URL_VOXELS2 =
  /^https:\/\/www\.voxels\.com\/spaces\/[a-f0-9]{8}-?[a-f0-9]{4}-?4[a-f0-9]{3}-?[89ab][a-f0-9]{3}-?[a-f0-9]{12}\/play$/

//abababab-aaaa-4aaa-aaaa-abababababab
export const UUID_STRING = /^[a-f0-9]{8}-?[a-f0-9]{4}-?4[a-f0-9]{3}-?[89ab][a-f0-9]{3}-?[a-f0-9]{12}$/
